import {
  WorkspaceMember as ApiWorkspaceMember,
  WorkspaceMembersResponse,
} from 'lib/generated/api'
import { WorkspaceMember } from 'types/entities'

export type WorkspaceMemberMapper = (
  data: ApiWorkspaceMember
) => WorkspaceMember
export const mapToWorkspaceMember: WorkspaceMemberMapper = data => {
  return {
    id: data.workspaceMemberId,
    createdAt: data.createdAt,
    email: data.email,
    status: data.status,
  }
}

export type WorkspaceMembersMapper = (
  data: WorkspaceMembersResponse
) => Omit<WorkspaceMembersResponse, 'results'> & { results: WorkspaceMember[] }
export const mapToWorkspaceMembers: WorkspaceMembersMapper = data => {
  const { results, ...rest } = data
  return {
    results: results.map(workspaceMember =>
      mapToWorkspaceMember(workspaceMember)
    ),
    ...rest,
  }
}
